import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { TaxonomyEntry } from 'src/redux/content/types';
import { selectResolvedPathname } from 'src/redux/navigation/selectors';
import { findEntryByUrl } from 'src/utils/selectTaxonomyContentEntry';

/**
 * The current URL's own entry, by an **exact** normalised lookup in the
 * neighbourhood map (`content.entries`) — no base/ancestor fallback.
 *
 * The shared basis for the page's meta robots ({@link selectIsCurrentUrlIndexable})
 * and canonical ({@link selectTaxonomyCanonical}) tags, so both read the same
 * entry and can't drift. Distinct from {@link selectMatchedTaxonomyEntry}, which
 * falls back to base/ancestor entries for *content* selection.
 */
export const selectExactTaxonomyEntry = (state: ReduxApplicationState): TaxonomyEntry | null =>
  findEntryByUrl(state.content.entries ?? [], selectResolvedPathname(state));
